import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_VEHICLE = {
  'model': '',
  'chassis': '',
  'salesDate': null,
};

const INITIAL_STATE_WARRANTY_CHASSIS = {
  'vehicle': INITIAL_VEHICLE,
  'vehicleExists': null,
  'loading': false,
};

export const warrantyVehicle = (state, action) => {
  return createReducer(INITIAL_STATE_WARRANTY_CHASSIS, {
    [ActionTypes.FETCHING_TWC_WARRANTY_CHASSIS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_TWC_WARRANTY_CHASSIS]: (state, action) => ({
      ...state,
      'loading': false,
      'vehicle': action.response.data,
      'vehicleExists': true,
    }),
    [ActionTypes.FETCHED_TWC_WARRANTY_CHASSIS_FAILED]: (state, action) => {
      return ({
        ...state,
        'loading': false,
        'vehicle': INITIAL_VEHICLE,
        'vehicleExists': false,
      });
    },
    [ActionTypes.ADDING_TWC_WARRANTY_CHASSIS]: (state, action) => {
      return ({
        ...state,
        'loading': true,
      });
    },
    [ActionTypes.ADDED_TWC_WARRANTY_CHASSIS]: (state, action) => {
      return ({
        ...state,
        'loading': false,
        'vehicle': action.response.data,
        'vehicleExists': true,
      });
    },
    [ActionTypes.ADDED_TWC_WARRANTY_CHASSIS_FAILED]: (state, action) => {
      return ({
        ...state,
        'loading': false,
        'vehicle': INITIAL_VEHICLE,
        'vehicleExists': false,
      });
    },
    [ActionTypes.CLEAR_WARRANTY_CHASSIS]: (state, action) => ({
      ...state,
      'loading': false,
      'vehicle': INITIAL_VEHICLE,
      'vehicleExists': null,
    }),
  })(state, action);
};
